import founder from "@/assets/optimized-images/founder.png";
import { MdOutlinePlayLesson, MdOutlineQuiz } from "react-icons/md";
import { FaRegBookmark } from "react-icons/fa6";
import { IoMdTimer } from "react-icons/io";
import { GiLevelEndFlag } from "react-icons/gi";
import { PiStudentFill } from "react-icons/pi";
import Rating from "../Rating/Rating";
import { Link } from "react-router-dom";

const AffliateBoard = ({
  lessonNumber,
  courseStudent,
  bookCaterory,
  courseTitle,
  ratings,
  toCategory,
}) => {
  return (
    <div className="bg-[#50a1df] grid px-3 sm:p-10 py-7 text-white font-[Mulish] text-sm gap-5">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-y-4">
        <div className="flex gap-2 items-center">
          <div className="rounded-full overflow-hidden">
            <img src={founder} alt="" width={45} />
          </div>
          <div className="space-y-1">
            <p>Instrutor</p>
            <p>Prof Yusuf</p>
          </div>
        </div>
        <div className="flex gap-2 items-center">
          <FaRegBookmark className="text-4xl text-[#004C97]" />
          <div className="space-y-1">
            <p>Category</p>
            <Link to={toCategory} className="hover:text-[#004C97]">
              <p>{bookCaterory}</p>
            </Link>
          </div>
        </div>
        <div className=" items-center space-y-1">
          <p>Review</p>
          <Rating ratings={ratings} />
        </div>
      </div>
      <div className="text-4xl font-[Roboto] font-bold py-5 sm:w-[80%]">
        <p>{courseTitle}</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-8 gap-y-5">
        <div className="flex gap-1">
          <IoMdTimer className="text-[#004C97] text-xl" />
          <p>Lifetime</p>
        </div>
        <div className="flex gap-1">
          <GiLevelEndFlag className="text-[#004C97] text-xl" />
          <p>All Levels</p>
        </div>
        <div className="flex gap-1">
          <MdOutlinePlayLesson className="text-[#004C97] text-xl" />
          <p>{lessonNumber} Lesson</p>
        </div>
        <div className="flex gap-1">
          <MdOutlineQuiz className="text-[#004C97] text-xl" />
          <p>0 Quizzes</p>
        </div>
        <div className="flex gap-1">
          <PiStudentFill className="text-[#004C97] text-xl" />
          <p>{courseStudent} Students</p>
        </div>
      </div>
    </div>
  );
};

export default AffliateBoard;
